module.exports = __webpack_public_path__ + "justtteddy.webp?8d9fc2d31cc13f471e61c8bc13c301d7";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/justtteddy.webp
// module id = 272
// module chunks = 0